// The dot-computed map layout (songs/map-layout.json): node positions + edges for
// the discovery map. Static (rebuilt by scripts/gen-map-layout.mjs); the runtime
// renders our SVG at these positions and overlays live curriculumState colours.
import type { LatticeEdge, LatticeNode } from "./song-lattice";

export interface LayoutNode extends LatticeNode {
  x: number;
  y: number;
  /** Stable 1-based number (reading order) for referring to a node; absent on root. */
  num?: number;
}
/** A lattice edge plus dot's routed spline (cubic B-spline control points, screen
 *  coords). Absent → the runtime falls back to a straight line. */
export interface LayoutEdge extends LatticeEdge {
  points?: [number, number][];
}
export interface MapLayout {
  nodes: LayoutNode[];
  edges: LayoutEdge[];
}

/** Load songs/map-layout.json (empty layout if absent). */
export async function loadMapLayout(): Promise<MapLayout> {
  try {
    const res = await fetch("songs/map-layout.json");
    if (!res.ok) return { nodes: [], edges: [] };
    return (await res.json()) as MapLayout;
  } catch {
    return { nodes: [], edges: [] };
  }
}
